import React from 'react'
import i2j from '../utils/i2j'

export default class SVG extends React.Component {
  state = { data: null };
  componentDidMount() {
    fetch(this.props.src).then((response) => {
      return response.text()
    }).then(text => {
      this.setState({ data: text })
    });

  }

  render() {
    return <div style={{position: 'relative', paddingBottom: `${this.props.height * 100 /this.props.width -10}%`}}>
      <div style={{...(this.props.style && i2j(this.props.style)), position: 'absolute', height: '100%', width: '100%'}} dangerouslySetInnerHTML={{__html: this.state.data}}/>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/svg.js